import { gql } from "@apollo/client";

export const GET_REFERRAL_FORMS_BY_ORG_ID = gql`
  query GetReferralFormByOrgId($orgId: ID!) {
    getForms(orgId: $orgId) {
      id
      url
      createdBy
      service {
        id
        orgId
        name
        alternateName
        url
        email
      }
      orgId
      formFields
      createdAt
      updatedAt
      status
      numberOfSubmissions
    }
  }
`;
